export default {
  statisApi: {
    getLawyersInfo: 'api/statisApi/getLawyersInfo',
    satisfactionInfo: 'api/statisApi/satisfactionInfo',
    consultationTrend: 'api/statisApi/consultationTrend',
    bussinessInfo: 'api/statisApi/bussinessInfo',
    crowdInfo: 'api/statisApi/crowdInfo',
    consultationsNumber: 'api/statisApi/consultationsNumber',
    lawyers: 'api/statisApi/lawyerTeam',
    lawyerSatisfaction: 'api/statisApi/lawyerSatisfaction',
  },
}
